import React, { useEffect } from 'react';
import { Menu, MenuItem, Tooltip, IconButton, Badge, makeStyles } from '@material-ui/core';
import { LanguageOutlined } from '@material-ui/icons';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { allLanguages } from '../../../../i18n/constants';

const useStyles = makeStyles((theme) => ({
  myClassName: {
    color: theme.palette.primary.main,
    position: 'relative',
    '&:hover': {
      color: 'white'
    }
  },
  iconButton: {
    [theme.breakpoints.down(990)]: {
      marginRight: '10px',
      '& span span svg': {
        fontSize: '1.3rem'
      }
    },
    color: theme.palette.primary.main,
    position: 'relative',
    '&:hover': {
      color: 'white'
    }
  }
}));

const ChangeLanguage = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const classes = useStyles();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    const { language: detectedLanguage } = i18n;
    const languageOnly = detectedLanguage.split('-')[0];

    if (allLanguages.includes(languageOnly)) {
      i18n.changeLanguage(languageOnly);
    } else {
      i18n.changeLanguage(allLanguages[0]);
    }
  }, [i18n]);

  return (
    <div>
      <Tooltip className='lang-changeLang' title={t('language:tooltip')}>

        <IconButton

          aria-controls='simple-menu'
          aria-haspopup='true'
          onClick={handleClick}
          className={classes.iconButton}
        >
          <Badge
            badgeContent={i18n.language}
            className={classes.myClassName}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right'
            }}
          >
            <LanguageOutlined fontSize='large' />
          </Badge>
        </IconButton>
      </Tooltip>
      <Menu
        id='simple-menu'
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        disableScrollLock
      >
        {allLanguages.map((lang) =>
          <MenuItem key={lang} onClick={() => {
            i18n.changeLanguage(lang);
            handleClose();
          }}>
            {lang} - {t(`language:${lang}`)}
          </MenuItem>
        )}
      </Menu>
    </div>
  );
};

export default withRouter(ChangeLanguage);
